import { tracking } from '@bark/bark-core';

export function StarterPackFlowOverride() {
	const { Bark } = window;

	if (!Bark.loadStarterPackFlow || Bark.loadStarterPackFlow !== true) {
		return;
	}


	const seller = (Bark.seller = Bark.seller || {});
	const originalCardModalSelector = seller.cardModalSelector;
	const originalPurchaseCreditsErrorModalSelector = seller.purchaseCreditsErrorModalSelector;

	seller.cardModalSelector = '.js-card-payment-modal'; // '#payment-card-with-summary-modal';
	seller.purchaseCreditsErrorModalSelector = '#purchaseCreditsError'; // '#payment-card-with-summary-modal';
	seller.starterPackModalSelector = '#starter-pack-modal';

	/**
	 * A different payment modal is used for the starter pack. Reset so that if required, the regular modal is shown
	 * next time
	 */
	const resetPaymentModalToAllowDefault = () => {
		seller.cardModalSelector = originalCardModalSelector;
		seller.purchaseCreditsErrorModalSelector = originalPurchaseCreditsErrorModalSelector;
		seller.$cardModal = null;
	};

	const bindPurchaseSuccessModalEvents = () => {
		$('.js-dismiss-complete-response')
			.off('click.dismissResponse')
			.on('click.dismissResponse', () => {
				resetPaymentModalToAllowDefault();
				$('#dashboard-starter-pack-payment-success-modal').modal('hide');
				tracking(
					'starter_pack_modal',
					'starter_pack_payment_success_not_right_now',
                    {
                        project_id: Bark.seller.currentlyShownProjectId,
                        seller_profile_id: Bark.seller.id
                    }
				);
			});

		$('.js-complete-response-after-purchase')
			.off('click.completeResponse')
			.on('click.completeResponse', () => {
				$('#dashboard-starter-pack-payment-success-modal').modal('hide');
				tracking(
					'starter_pack_modal',
					'starter_pack_payment_success_contact_buyer',
                    {
                        project_id: Bark.seller.currentlyShownProjectId,
                        seller_profile_id: Bark.seller.id
                    }
				);
				seller.submitYourDetailsCall(
					seller.currentlyShownProjectId,
					seller.lastAttemptedResponseType === 'oneClickResponse',
				);
			});
	};

	const setCardFormSubmitButton = (buttonsForExisting) => {
		const saveNewCardButton = $(`${seller.cardModalSelector} .js-card-modal-confirm`);
		const existingCardButton = $(`${seller.cardModalSelector} .js-submit-existing-card`);

		existingCardButton[buttonsForExisting ? 'removeClass' : 'addClass']('d-none');
		saveNewCardButton[buttonsForExisting ? 'addClass' : 'removeClass']('d-none');

		if (buttonsForExisting) {
			existingCardButton.off('click.buyWithExisting').on('click.buyWithExisting', () => {
				$(seller.cardModalSelector).modal('hide');
				seller.purchaseStarterPack();
			});
		}
	};

	const bindChangeCardEvent = () => {
		$(`${seller.cardModalSelector} .js-change-card`)
			.off('click.changeCard')
			.on('click.changeCard', () => {
				$(`${seller.cardModalSelector} .js-card-existing-info`).addClass('d-none');
				$(`${seller.cardModalSelector} .js-card-main-form`).removeClass('d-none');
				setCardFormSubmitButton(false);
				seller.hasCard = false;
				seller.cardId = null;
			});
	};

	seller.bindStarterPackModalEvents = () => {
		$('.js-starter-pack-accordion-header')
			.off('click.tracking')
			.on('click.tracking', ({ currentTarget }) => {
				const title = currentTarget?.dataset?.title ?? false;

				if (title) {
					tracking('starter_pack_modal', 'starter_pack_modal_info', {
						title,
						is_opening: Number(currentTarget.classList.contains('collapsed')),
                        project_id: Bark.seller.currentlyShownProjectId,
                        seller_profile_id: Bark.seller.id
					});
				}
			});
	};

	/**
	 * Mostly lifted from seller-dashboard.js
	 * @param {jQuery} btn
	 */
	seller.initPurchaseStarterPack = (btn) => {
		seller.debug(
			`${seller.starterPackModalSelector} .purchase-upsell-welcome-offer - click`,
		);
        if (window.hj) {
            try {
                window.hj('event', 'starter_pack_experiment_credit_modal_open');
            } catch (e) {
                bugsnagClient && bugsnagClient.notify(e);
            }
        }

        Bark.recordHotjarEvent('starter-pack-purchase-click');
        const modal = $(seller.cardModalSelector);
		const { savings, discountPercent, originalPrice } = btn.data();
		const nCredits = btn.data('ncredits');
        const rawDiscountPrice = btn.data('discountprice-raw');
		const ppc = rawDiscountPrice / nCredits;
		const totalPack = btn.data('discountprice');
		const hasVat = btn.data('has-vat');
		const packId = btn.data('pack-id');
		const project = seller.getProjectDataById(seller.currentlyShownProjectId);

		$('.js-n-credits', modal).text(nCredits);
		$('.js-original-price', modal).text(originalPrice);
		$('.js-price', modal).text(totalPack);
		$('.js-discount-pct', modal).text(discountPercent);
		$('.js-amount-saved', modal).text(savings);
		$('.js-card-decline-reason', modal).addClass('d-none');

		seller.paymentType = 'pack_upsell_welcome';
		seller.planId = 'spack';
		seller.autoTopupAvailable = 1;
		seller.setAutoTopup = Number($('#autotop-enabler-starter-pack').is(':checked'));

		ga('send', 'event', 'seller respond', 'button click', 'buy now - starter pack');

		tracking('starter_pack_modal', 'starter_pack_modal_buy_now', {
			project_id: seller.currentlyShownProjectId,
            seller_profile_id: seller.id
		});

		if (!project) {
			return false;
		}

		if (seller.hasCard) {
			$('.js-card-existing-info', modal).removeClass('d-none');
			$('.js-card-main-form', modal).addClass('d-none');
			$('.js-card-last-four', modal).text(seller.cardLast4);
			seller.debug('has card details');
			seller.currentModalSelector = '#sellerResponseCreditPackUpsell1';

			$(`${seller.starterPackModalSelector} .purchase-upsell-welcome-offer`).prop(
				'disabled',
				true,
			);
			$(seller.starterPackModalSelector).modal('hide');
			bindChangeCardEvent();
		} else {
			// Doesn't have card details, show the credit card modal
			$('.js-card-existing-info', modal).addClass('d-none');
			$('.js-card-main-form', modal).removeClass('d-none');
			$(seller.starterPackModalSelector).modal('hide');
			seller.debug('does not have card details');

			ga('set', 'page', window.location.pathname + 'credits-upsell/payment/');
			ga('send', 'pageview');
		}

		const modalOptions = seller.generateCardModalOptions(true, nCredits, ppc, rawDiscountPrice);

		setCardFormSubmitButton(false);

        if (Bark.seller.isMultiPaymentModalAvailable()) {
            Bark.seller.showMultiplePaymentEntryForm(Bark.seller.generateMultiPaymentModalOptions(false, nCredits, null, null));
        } else {
            Bark.seller.showCardEntryForm(modalOptions);
        }

        seller.lastPackModalSelector = seller.starterPackModalSelector;
	};

	seller.showStarterPackPurchaseConfirmationModal = () => {
		const modal = $('#dashboard-starter-pack-payment-success-modal');
		const { buyer_share_name, credits_required } = seller.getProjectDataById(
			seller.currentlyShownProjectId,
		);

		seller.hideProjectInteractionLoader();

		$('.js-buyer-name', modal).text(buyer_share_name);
		$('.js-n-credits-label', modal).text(
			`${credits_required} credit${+credits_required === 1 ? '' : 's'}`,
		);

		bindPurchaseSuccessModalEvents();
		modal.modal('show');
	};
}
